// extracted by mini-css-extract-plugin
export default {"acerca":"Acerca_acerca__cKuKO"};